import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OnDeviceTrainingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"on_device_training"}/>
}
